import { useParams } from "react-router-dom";
import { VesselDisplay } from "@smartship-services/ui";

const VesselPage = () => {
  const { vesselId = "" } = useParams();
  return <VesselDisplay vesselId={vesselId} />;
};

export default VesselPage;
